var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 2.85714H2.17994L4.22989 0.808057L3.42857 0L0 3.42857L3.42857 6.85714L4.22989 6.0488L2.18166 4H9.14286C10.0522 4 10.9242 4.36122 11.5672 5.00421C12.2102 5.64719 12.5714 6.51926 12.5714 7.42857C12.5714 8.33789 12.2102 9.20996 11.5672 9.85294C10.9242 10.4959 10.0522 10.8571 9.14286 10.8571H4.57143V12H9.14286C10.3553 12 11.518 11.5184 12.3753 10.6611C13.2327 9.80375 13.7143 8.64099 13.7143 7.42857C13.7143 6.21615 13.2327 5.05339 12.3753 4.19608C11.518 3.33877 10.3553 2.85714 9.14286 2.85714Z",
    fill: "#6B54F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.70a75fcd.svg";
export { ForwardRef as ReactComponent };